import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

import * as Customer from '@/services/rest-api/lib/customer/customer'
import * as Driver from '@/services/rest-api/lib/fleet-task/driver'
import * as Vehicle from '@/services/rest-api/lib/fleet-task/vehicle'
import * as BoxType from '@/services/rest-api/lib/fleet-task/box-type'

export const tableFilterFields = {
  computed: {
    tableFilterFields() {
      return [
        {
          name: 'delivered_on',
          isShow: true,
          label: this.$t('report.fields.deliveryDate'),
          type: 'date-picker',
          datepickerType: 'date',
          valueType: 'YYYY-MM-DD',
          format: 'DD MMM YYYY',
          titleFormat: 'DD MMM YYYY',
          rangeSeparator: ' - ',
          range: true,
          draft: true,
          confirm: true,
          confirmText: this.$t('global.action.apply'),
          clearable: false,
          disabledDate: (date) => {
            let limit = new Date()
            return date <= this.pastDate || date >= this.futureEnd || date > limit
          },
          shortcuts: [
            {
              text: this.$t('global.time.today'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setHours(0, 0, 0)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
            {
              text: this.$t('global.time.yesterday'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setDate(startDate.getDate() - 1)
                startDate.setHours(0, 0, 0)
      
                endDate.setDate(endDate.getDate() - 1)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
            {
              text: this.$t('global.time.last3Days'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setDate(startDate.getDate() - 2)
                startDate.setHours(0, 0, 0)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
            {
              text: this.$t('global.time.last7Days'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setDate(startDate.getDate() - 6)
                startDate.setHours(0, 0, 0)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
            {
              text: this.$t('global.time.last31Days'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setDate(startDate.getDate() - 30)
                startDate.setHours(0, 0, 0)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
          ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick })),
        },
        {
          name: 'box_type_id',
          isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
          label: this.$t('report.fields.boxType'),
          type: 'value-help-v2',
          placeholder: `${this.$t('global.form.select')} ${this.$t('report.fields.boxType')}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: BoxType.get,
          multiple: true,
          tableFields: [
            {
              label: this.$t('report.fields.boxType'),
              key: 'name',
              isSortable: true,
            },
          ],
        },
        {
          name: 'vehicle_id',
          isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
          label: this.$t('global.object.licensePlate'),
          type: 'value-help-v2',
          placeholder: `${this.$t('global.form.select')} ${this.$t('global.object.licensePlate')}`,
          trackBy: 'id',
          displayedBy: 'license_plate',
          listGetter: Vehicle.get,
          multiple: true,
          tableFields: [
            {
              label: this.$t('global.object.licensePlate'),
              key: 'license_plate',
              isSortable: true,
            },
          ],
        },
        {
          name: 'driver_id',
          isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
          label: this.$t('global.driver'),
          type: 'value-help-v2',
          placeholder: `${this.$t('global.form.select')} ${this.$t('global.driver')}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Driver.get,
          multiple: true,
          tableFields: [
            {
              label: this.$t('global.driver'),
              key: 'name',
              isSortable: true,
            },
          ],
        },
        {
          name: 'customer_id',
          isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
          label: this.$t('delivery.fields.shippedCustomerName'),
          type: 'value-help-v2',
          placeholder: `${this.$t('global.form.select')} ${this.$t('delivery.fields.shippedCustomerName')}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Customer.get,
          multiple: true,
          tableFields: [
            {
              label: this.$t('global.object.customerName'),
              key: 'name',
              isSortable: true,
            },
          ],
        }
      ]
    }
  }
}

